import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { QueryModel } from '../share/paginationquery.model';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { TerminalConnectivityStatusReport } from './terminal-connectivity-status.type';
import { Zone } from '../share/zones/zone.model';
import { CostCenterService } from '../share/costCenter/costcenter.service';
import { ReportsService } from '../share/reports/report.service';
import { LocationConnectionStatus } from '../share/enums/locationConnectionStatus';
import { AppSettings } from '../../settings';

@Component({
  selector: 'app-terminal-connectivity-status-report',
  templateUrl: './terminal-connectivity-status-report.component.html',
  styleUrls: ['./terminal-connectivity-status-report.component.css'],
  providers: [CostCenterService, ReportsService]
})
export class TerminalConnectivityStatusReportComponent implements OnInit {

  terminalConnectivityStatuses: TerminalConnectivityStatusReport[] = [];
  currentPageNumber = 1;
  currentDetailsIndex = -1;
  isLoadDetails = false;
  connectionStatusId: number;
  connectionStatuses: any[] = [];
  zones: Zone[] = [];
  allZones: Zone = new Zone();
  zoneId: number = null;
  zoneIds: number[] = [];
  isLoading = false;
  order = '';
  recordsPerPage: number;
  query: QueryModel = new QueryModel();
  filterValue: string;
  readonly collapsedDetailsIndex = -1;

  constructor(
    private _translate: TranslateService,
    private _costCenterService: CostCenterService,
    private _spinner: NgxSpinnerService,
    private _toastrService: ToastrService,
    private _reportsService: ReportsService,
    private _settings: AppSettings
  ) {
    this.recordsPerPage = _settings.recordsPerPage;
  }

  ngOnInit() {
    this.getZones();
    this.connectionStatuses = this.getTerminalConnectionStatuses();
  }

  getZones() {
    this._costCenterService.httpGetZones()
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
        data => {
          if (data !== undefined) {
            this.zones = data;
            this.allZones.name = 'AllZones';
            this.allZones.zoneId = -10;
            this.zones.unshift(this.allZones);
          }
        },
        err => {
          throw err;
        });
  }

  search() {
    if (this.zoneId != null) {
      this.isLoading = true;

      if (this.zoneId === -10) {
        this.zoneIds = this.zones.map(z => z.zoneId);
      } else {
        this.zoneIds = [];
        this.zoneIds.push(this.zoneId);
      }

      if (this.isDetailsPreviewOpen()) {
        this.closeDetailsPreview();
      }
      this.loadTerminalConectivityStatusesReportList();
    } else {
      this._translate.get('Messages.InvalidSearchTerminalConnectivityStatus').subscribe(translated => {
        this._toastrService.warning(translated);
      });
    }
  }

  loadTerminalConectivityStatusesReportList() {
    this._spinner.show();
    this.currentPageNumber = 1;

    this._reportsService.httpGetTerminalConnectivityStatusesReport(this.zoneIds, this.connectionStatusId)
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
      (data: TerminalConnectivityStatusReport[]) => {
        if (data !== undefined) {
          this.terminalConnectivityStatuses = data.filter(item => item.terminalId > 0);

          if (this.terminalConnectivityStatuses === undefined || this.terminalConnectivityStatuses.length === 0) {
            this._translate.get('Messages.NoData').subscribe(translated => {
              this._toastrService.warning(translated);
            });
          }
        }
      },
      err => {
        throw err;
      }, () => this.isLoading = false
    );
  }

  getColorByOnlineStatus(report) {
    if (report.locationConnectionStatus === null)
      return this._settings.unknownConnectionStatusColor;

    if (report.locationConnectionStatus === LocationConnectionStatus.Online)
      return this._settings.onlineConnectionStatusColor;
    else if (report.locationConnectionStatus === LocationConnectionStatus.Offline)
      return this._settings.offlineConnectionStatusColor;
  }

  getTerminalConnectionStatuses() {
    return Object.keys(LocationConnectionStatus).filter(key => isNaN(Number(key))).map(key =>
      ({
        id: LocationConnectionStatus[key],
        name: key
      }));
     }

     sort(propertyName) {
      if (this.currentDetailsIndex > this.collapsedDetailsIndex) return;
      if (this.order === propertyName) {
        this.order = '-' + propertyName;
      } else if (this.order === '-' + propertyName) {
        this.order = propertyName;
      } else {
        this.order = propertyName;
      }
    }

    getTerminalNameAndCityAsString(report) {
      if (report.terminalCity !== null && report.terminalCity !== undefined)
        return report.terminalName + ' ' + '(' + report.terminalCity + ')';

      return report.terminalName;
    }

    onSearchTextChange() {
      if (this.isDetailsPreviewOpen()) {
        this.closeDetailsPreview();
      }
    }

    closeDetailsPreview() {
      this.isLoadDetails = false;
      this.currentDetailsIndex = this.collapsedDetailsIndex;
    }

    onKeyDown(event) {
      if (event.key === 'Enter') {
        this.removeFocus();
      }
    }

    isDetailsPreviewOpen() {
      return this.isLoadDetails && this.currentDetailsIndex !== this.collapsedDetailsIndex ? true : false;
    }

    removeFocus() {
      (document.activeElement as HTMLElement).blur();
    }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/terminal-connectivity-status-report/terminal-connectivity-status-report.component.ts